<template>
  <div class="result" v-if="loadingIsCompleted">
    <div class="screen-only">
      <v-alert :value="true" color="info" icon="info" outline
        >A3横向きで印刷してください。</v-alert
      >
      <v-btn @click="print">印刷</v-btn>
    </div>
    <section class="sheet">
      <title-and-name
        class
        title="サーベイシート"
        :name="result.info.subjectName"
      />

      <result-table
        :values="result.select_questions"
        :ops="result.select_options"
        class="result-table"
      />
      <div>
        <summary-table
          :values="result.summary"
          :ops="result.select_options"
          :categories="result.select_categories"
          id="summary-table"
        />
        <radar-chart
          class="radar-chart"
          :values="result.summary"
          :ops="result.select_options"
          :categories="result.select_categories"
        />
        <div class="summary-of-this-all-surveys">
          <h3>全体分布比率（％）</h3>
          <table>
            <tbody>
              <tr style="font-size: 10px; height: 3mm">
                <th>分類</th>
                <th style="width: 10mm; text-align: center">~1.5</th>
                <th style="width: 10mm; text-align: center">1.5~</th>
                <th style="width: 10mm; text-align: center">2.0~</th>
                <th style="width: 10mm; text-align: center">2.5~</th>
                <th style="width: 10mm; text-align: center">3.0~</th>
                <th style="width: 10mm; text-align: center">3.5~</th>
                <th style="width: 10mm; text-align: center">4.0~</th>
                <th style="width: 10mm; text-align: center">4.5~</th>
                <th style="width: 10mm; text-align: center">5.0~</th>
                <th style="width: 10mm; text-align: center">5.5~</th>
              </tr>
              <tr
                style="font-size: 10px; height: 2.5mm"
                v-for="label in Object.keys(summaryRate)"
                :key="label"
              >
                <td>{{ label }}</td>
                <template v-for="(c, i) in summaryRate[label]">
                  <td :key="i" style="width: 10mm; text-align: center" :class="{'range-as-owner':selfSummaryCount[label][i]>0}">
                    {{ c }}
                  </td>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
        <div id="table-legends">
          <h3>点数と回答</h3>
          <table style="width: 80mm">
            <tr
              v-for="ops in result.select_options"
              :key="ops.value"
              style="font-size: 10px; height: 3mm"
            >
              <td style="padding: 1pt; width: 10mm; text-align: center">
                {{ ops.value }}
              </td>
              <td style="padding: 1pt">{{ ops.label }}</td>
            </tr>
          </table>
        </div>
      </div>
    </section>

    <section class="sheet">
      <title-and-name
        class
        title="アドバイスシート"
        :name="result.info.subjectName"
      />

      <div class="comment-box print-item other-comment comment-1">
        <h3>≪対象者の優れているところ/良いと思うところ≫</h3>
        <p
          v-for="(c, i) in result.comment_questions[2].comments.coWorker"
          :key="i"
        >
          ・{{ c.trim() }}
        </p>
      </div>
      <div class="comment-box print-item other-comment comment-2">
        <h3>≪対象者の気になるところ・改善してほしいところ≫</h3>
        <p
          v-for="(c, i) in result.comment_questions[3].comments.coWorker"
          :key="i"
        >
          ・{{ c.trim() }}
        </p>
      </div>
      <div class="comment-box print-item other-comment comment-3">
        <h3>≪対象者に期待していること≫</h3>
        <p
          v-for="(c, i) in result.comment_questions[4].comments.coWorker"
          :key="i"
        >
          ・{{ c.trim() }}
        </p>
      </div>
      <div class="comment-box print-item self-comment comment-1">
        <h3>≪自分の優れているところ/良いと思うところ≫</h3>
        <p
          v-for="(c, i) in result.comment_questions[2].comments.subject"
          :key="i"
        >
          ・{{ c.trim() }}
        </p>
      </div>
      <div class="comment-box print-item self-comment comment-2">
        <h3>≪自分で改善すべきと思うところ≫</h3>
        <p
          v-for="(c, i) in result.comment_questions[3].comments.subject"
          :key="i"
        >
          ・{{ c.trim() }}
        </p>
      </div>
      
    </section>
  </div>
</template>


<script>
import ResultTable from "@/components/result_print/result_table.vue";
import SummaryTable from "@/components/result_print/summary_table.vue";
import InfoTable from "@/components/result_print/info_table.vue";
import TitleAndName from "@/components/result_print/title_and_name.vue";
import RadarChart from "@/components/result_print/radar_chart.vue";
import { mean, standardDeviation, max } from "simple-statistics";
import { roundAndToFixed, frequency } from "@/utils/statics.js";
import db from "@/components/firebaseInit";
import { mapGetters } from "vuex";
// this.result = {
//   select_questions: this.items,
//   select_options: this.selectOptions,
//   select_categories: this.categories,
//   comment_questions: this.commentSections,
//   summary: this.summaryItems,
//   info: this.infoItems,
//   subject: subjectInfo
// };

export default {
  components: {
    ResultTable,
    SummaryTable,
    InfoTable,
    TitleAndName,
    RadarChart,
  },
  data() {
    return {
      surveyDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id),
      answerDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("answer_sheets"),
      resultsDbRef: db
        .collection("companies")
        .doc(this.$route.params.company_id)
        .collection("surveys")
        .doc(this.$route.params.survey_id)
        .collection("results"),
      items: [],
      answers: [],
      allResults: [],
      survey: null,
      active: null,
      categorys: [],
      questions: [],
      selectSections: [],
      selectOptions: [],
      commentSections: {},
      summary: { avgSelf: null, avgScore: null, sdScore: null },
      summaryItems: {},
      summaryItems2: {},
      result: {},
      loadingIsCompleted: false,
      summaryCount: {},
      summaryRate: {},
      selfSummaryCount: {},
    };
  },
  async created() {
    await this.getResult();
    await this.getAllResults();
  },
  methods: {
    async getResult() {
      const doc = await this.resultsDbRef.doc(this.$route.params.user_id).get();
      if (doc.exists) {
        this.result = doc.data();
        this.loadingIsCompleted = true;
      } else {
        //TODO
      }
    },
    async print() {
      const subject = this.result.subject;
      document.title =
        subject.No + "_" + subject.name.replace(/\s+/g, "") + "様";
      window.print();
    },
    avg(values) {
      let sum = values.reduce((pre, curr, i) => pre + curr);
      return Math.round((sum / values.length) * 10) / 10;
    },
    async getAllResults() {
      this.allResults = [];
      const summaries = {};

      const labels = this.result.select_categories;
      labels.forEach((label) => {
        summaries[label] = [];
        this.summaryCount[label] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.summaryRate[label] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
        this.selfSummaryCount[label] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      });

      labels.forEach((label) => {
        const v = this.round(mean(this.result.summary[label].score), 2);
        const i = Math.floor(v / 0.5);
        if (i <= 2) {
          this.selfSummaryCount[label][0]++;
        } else {
          this.selfSummaryCount[label][i - 2]++;
        }
      });

      const querySnapshot = await this.resultsDbRef.get();
      const subjectCount = querySnapshot.size;
      querySnapshot.forEach((doc) => {
        const ans = doc.data();

        if (doc.exists) {
          this.allResults.push(ans);
          Object.keys(ans.summary).forEach((label) => {
            const v = this.round(mean(ans.summary[label].score), 2);
            summaries[label].push(v);
            const i = Math.floor(v / 0.5);
            if (i <= 2) {
              this.summaryCount[label][0]++;
            } else {
              this.summaryCount[label][i - 2]++;
            }
          });
          Object.keys(this.summaryCount).forEach((label) => {
            const l = this.summaryCount[label].length;
            this.summaryCount[label].forEach((v, i) => {
              this.summaryRate[label][i] = this.round(
                (v / subjectCount) * 100,
                1
              );
            });
          });
          this.summaryRate = Object.assign({}, this.summaryRate);
        }
      });
    },
    round(value, demical) {
      const n = Math.pow(10, demical);
      return (Math.round(value * n) / n).toFixed(demical);
    },
    async getAnswers() {
      this.answers = [];
      const querySnapshot = await this.answerDbRef
        .where("subject_id", "==", this.user.uid)
        .get();
      querySnapshot.forEach((doc) => {
        const ans = doc.data();
        if (ans.status && ans.status == "完了") {
          this.answers.push(ans);
        }
      });
      this.getSurvey();
    },
    async getSurvey() {
      const doc = await this.surveyDbRef.get();
      this.survey = doc.data();
      this.commentSections = { index: [] };
      this.survey.question_sheet.sections
        .filter((s, i) => {
          if (s.type == "SelectQuestions") {
            this.selectSections.push(i);
            return true;
          } else if (s.type == "CommentQuestions") {
            this.commentSections.index.push(i);
            this.commentSections[i] = {
              isShow: s.isShow,
              comments: { subject: [], coWorker: [] },
            };
          }
        }, this)
        .forEach((s) => {
          s.questions.forEach((q) => this.questions.push(q));
        });
      this.categorys =
        this.survey.question_sheet.sections[
          this.selectSections[0]
        ].categoryList;
      this.categorys.forEach((c) => {
        this.summaryItems[c] = { category: c, selfs: [], score: [] };
      });
      this.selectOptions =
        this.survey.question_sheet.sections[
          this.selectSections[0]
        ].selectOptions;
      this.account();
    },
    account() {
      const subjectAns = this.answers.filter((a) => a.type == "subject")[0];
      const coWorkerAns = this.answers.filter((a) => a.type == "coWorker");

      //account select questions
      this.items = this.questions.map((q) => {
        const score = [];
        coWorkerAns.forEach((a) => {
          if (a.result[this.selectSections[0]][q.id]) {
            const s = Number(a.result[this.selectSections[0]][q.id]);
            this.summaryItems[q.category].score.push(s);
            score.push(s);
          }
        }, this);
        const self = Number(subjectAns.result[this.selectSections[0]][q.id]);

        this.summaryItems[q.category].selfs.push(self);
        this.summaryItems2 = Object.assign({}, this.summaryItems);

        return {
          id: q.id,
          question: q.question,
          category: q.category,
          score: score,
          boss: score[0],
          self: self,
        };
      });

      //account coWorker's comments
      coWorkerAns.forEach((a) => {
        this.commentSections.index.forEach((i) => {
          if (a.result[i].length > 0) {
            this.commentSections[i].comments.coWorker.push(
              ...a.result[i].filter((c) => c.length > 0)
            );
          }
          debugger;
          for (
            let j = this.commentSections[i].comments.coWorker.length - 1;
            j > 0;
            j--
          ) {
            const rand = Math.floor(Math.random() * (j + 1));
            [
              this.commentSections[i].comments.coWorker[j],
              this.commentSections[i].comments.coWorker[rand],
            ] = [
              this.commentSections[i].comments.coWorker[rand],
              this.commentSections[i].comments.coWorker[j],
            ];
          }
        });
      });

      //account subject's comments
      this.commentSections.index.forEach((i) => {
        if (subjectAns.result[i].length > 0) {
          this.commentSections[i].comments.subject.push(
            ...subjectAns.result[i].filter((c) => c.length > 0)
          );
        }
      });
      this.good = this.commentSections[2].comments.coWorker;
      this.bad = this.commentSections[3].comments.coWorker;
      this.except = this.commentSections[4].comments.coWorker;

      this.self_good = this.commentSections[2].comments.subject;
      this.self_bad = this.commentSections[3].comments.subject;

      // //account info table
      // this.infoItems.subjectName = subjectAns.subject_name
      // this.infoItems.startDate= this.survey.start_date
      // this.infoItems.endDate= this.survey.pre_end_date
      // this.infoItems.numOfCoWorker = coWorkerAns.length
      // this.loading = false
    },
  },
  computed: {
    ...mapGetters("auth", ["isLoggedIn", "user"]),
  },
};

function range(n) {
  const a = [];
  for (let i = 0; i < n; ++i) a.push(i);
  return a;
}
</script>


<style lang="scss" scoped>
@media screen {
  .screen-only {
    font-size: large;
  }
  .sheet {
    background: white; /* 背景を白く */
    box-shadow: 0 0.5mm 2mm rgba(0, 0, 0, 0.3); /* ドロップシャドウ */
    margin: 5mm;
  }
  .result {
    overflow: scroll;
    white-space: nowrap;
  }
}

.result-row {
  margin: 10px 0;
}

@page {
  size: A3 landscape;
  margin: 0;
}
@media print {
  .screen-only {
    display: none;
  }
  .result section:first-of-type {
    margin-top: -88px;
    // App.vue のv-content(<main>) に64px、 v-containerに24pxのpaddingがあるため、最初のセクションを88px上方向に調整
  }
  * {
    -webkit-transition: none !important;
    transition: none !important;
  }
}

.sheet {
  width: 410mm;
  height: 285mm;
  padding: 3mm;
  page-break-after: always;
  position: relative;
}
.sheet:last-child{
    page-break-after: auto; /* 最後のページの改ページを防ぐ */
}

.print-item {
  position: absolute;
}
#summary-table {
  //width: 100%;
  position: absolute;
  top: 240mm;
}
.radar-chart {
  position: absolute;
  top: 240mm;
  left: 110mm;
}
.summary-of-this-all-surveys {
  position: absolute;
  top: 240mm;
  left: 190mm;
}
$table-legends-width: 80mm;
#table-legends {
  width: $table-legends-width;
  position: absolute;
  top: 240mm;
  left: 325mm;
}
h3 {
  margin-bottom: 5pt;
}
.categoryTitle {
  margin-top: 25px;
  margin-bottom: 10px;
}
img#logo {
  top: 200pt;
  left: 145pt;
}
#company-name {
  top: 350pt;
  font-size: 30pt;
  left: 445pt;
}
#info-table {
  top: 25pt;
  left: 15pt;
}

#all-chart {
  top: 200pt;
  left: 15pt;
}
.result-table {
  left: 15pt;
}
$comment-box-width: 125mm;
.comment-box {
  width: $comment-box-width; /* ボックスの横幅を指定 */

  border: 1px solid rgba(0, 0, 0, 0.5); /* 境界線を実線で指定 */
  /* border-radius: 10px;	ボックスの四つ角を丸くする */
  text-align: left;
  padding: 5pt;
  p {
    margin-bottom: 3pt;
    word-wrap: break-word;
    white-space: normal;
    font-size: 10px;
  }
}
.other-comment {
  height: 200mm; /* ボックスの高さを指定 */
  top: 20mm;
}
.self-comment {
  height: 40mm; /* ボックスの高さを指定 */
  top: 225mm;
}

$comment-box-left: 20pt;
$comment-box-margin: 10pt;

.comment-1 {
  left: $comment-box-left;
}
.comment-2 {
  left: $comment-box-left + $comment-box-width + $comment-box-margin;
}
.comment-3 {
  left: $comment-box-left + ($comment-box-width + $comment-box-margin) * 2;
}
table {
  border-collapse: collapse;
  border: 1px solid rgba(0, 0, 0, 0.5);
  table-layout: fixed;
  font-size: 9pt;
  tr,
  td,
  th {
    border-collapse: collapse;
    border: 1px solid rgba(0, 0, 0, 0.5);
  }
  td {
    padding: 5pt;
  }
  td.range-as-owner{
    -webkit-print-color-adjust: exact;
    background-color: #FADBDA;
  }
}
table#name {
  font-size: 16px;
  position: absolute;
  bottom: 0%;
}
</style>
